import { StateService } from '@uirouter/angularjs';
import * as angular from 'angular';
import { BackToDashboardService } from '../../../app.common/modules/common/services/back-to-dashboard.service';
import { AccountService } from '../account/account.service';
import { IUser } from '../account/model';
import { IMenu, NavigationService } from '../common/services/navigation.service';
import { IRetailerRootScope } from '../core/models';

class HomeScreenController {
  public static $inject = ['$rootScope', '$scope', '$translate', 'accountService', 'navigationService', 'backToDashboardService', '$state'];

  public warningsCount: string;
  public adminMenu: IMenu;
  public isNfrnRetailer: boolean;

  constructor(
    private $rootScope: IRetailerRootScope,
    private $scope: ng.IScope,
    private $translate: angular.translate.ITranslateService,
    private accountService: AccountService,
    private navigationService: NavigationService,
    private backToDashboardService: BackToDashboardService,
    private $state: StateService
  ) {
    this.getWarnings();
    const unwatch = $rootScope.$watch('userData', async (userData: IUser) => {
      if (userData.permission) {
        unwatch();
        this.adminMenu = navigationService.getAdminMenu();
        this.isNfrnRetailer = userData.permission === this.$rootScope.enums.RetailerPermission.Nfrn;
        if (userData.permission === this.$rootScope.enums.RetailerPermission.Publisher) {
          this.$state.go('app.products');
        }
      }
    }, true);
  }

  public logOff(redirectToHomepage?: boolean) {
    this.accountService.logOut(redirectToHomepage);
  }

  public canNavigateBack(): boolean {
    return !!this.backToDashboardService.dashboardLink;
  }

    private getWarnings() {
        // Fake retrieving warnings count from api
        const warningsCount = 0;
        const promise = new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(warningsCount);
            }, 500);
        });

        promise.then((result) => {
            this.warningsCount = result.toString();
        });
    }
}

angular
  .module('naut')
  .component('homeScreen', {
    template: require('./homeScreen.component.html'),
    controller: HomeScreenController,
    controllerAs: 'ctrl'
  });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/home/homeScreen.component.ts